import { render, staticRenderFns } from "./furnitureshop-faq.vue?vue&type=template&id=1f854b91&scoped=true&"
import script from "./furnitureshop-faq.vue?vue&type=script&lang=js&"
export * from "./furnitureshop-faq.vue?vue&type=script&lang=js&"
import style0 from "./furnitureshop-faq.vue?vue&type=style&index=0&id=1f854b91&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f854b91",
  null
  
)

export default component.exports